import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'
import { SkeletonRegion } from './_shared'
import { CardGridSkeleton } from './card-grid-skeleton'
import { DetailSkeleton } from './detail-skeleton'
import { TableSkeleton } from './table-skeleton'

export interface PageShellSkeletonProps {
	body?: 'table' | 'cards' | 'detail'
	withToolbar?: boolean
	withHeader?: boolean
	withCheckbox?: boolean
	withPager?: boolean
	withDisplay?: boolean
	cols?: number
	className?: string
	label?: string | false
}

export function PageShellSkeleton({
	body = 'table',
	withToolbar = true,
	withHeader = true,
	withCheckbox = true,
	withPager = true,
	withDisplay = true,
	cols,
	className,
	label = 'Loading',
}: PageShellSkeletonProps) {
	return (
		<SkeletonRegion label={label} className={cn('flex size-full min-h-0 flex-col gap-4', className)}>
			{withHeader ? (
				<div className='flex shrink-0 items-center justify-between'>
					<Skeleton className='h-control w-48 rounded-md' />
					<Skeleton className='h-control w-28 rounded-md' />
				</div>
			) : null}
			{withToolbar ? (
				<div className='flex min-h-[30px] shrink-0 items-center justify-between gap-4 px-4'>
					<Skeleton className='h-control w-(--search-width) max-w-full' />
					<div className='flex shrink-0 items-center gap-3'>
						{withPager ? <Skeleton className='h-control w-60' /> : null}
						{withDisplay ? <Skeleton className='h-control w-9' /> : null}
					</div>
				</div>
			) : null}
			<div className='min-h-0 flex-1'>
				{body === 'cards' ? (
					<CardGridSkeleton label={false} />
				) : body === 'detail' ? (
					<DetailSkeleton label={false} />
				) : (
					<TableSkeleton label={false} showCheckbox={withCheckbox} cols={cols} />
				)}
			</div>
		</SkeletonRegion>
	)
}
